import * as WebFont from "webfontloader";

WebFont.load({
  google: {
    families: ["Ubuntu:300,400,500,700"],
  },
});



// WEBPACK FOOTER //
// app/javascript/shared/fonts.js